<template>
  <a-form
    layout="horizontal"
  
  >
    <a-form-item
        v-bind="formItemLayout"
    >
        <h3
            slot="label"
        >
            {{ label }}
        </h3>
        <div>
            <a-checkbox
                v-if="checkAllBox"
                :indeterminate="allIndeterminate"
                v-on:change="checkAllChange"
                :checked="allChecked"
            >
                Összes
            </a-checkbox>
        </div>
        <a-checkbox-group
            v-decorator="[
                'file_types'
            ]"
            v-on:change="selectionChange"
            :value="selected"
        >
            <a-row
                class="checkbox-group-row"
            >
                <a-col
                    :span="24"
                    v-for="fileType in options"
                    :key="fileType.value"
                >
                    <a-checkbox
                        :value="fileType.value"
                    >
                        {{ fileType.label }}
                    </a-checkbox>
                </a-col>
            </a-row>
        </a-checkbox-group>
    </a-form-item>
  </a-form>
</template>

<script>

export default {
    name: 'SearchCheckboxes',
    props: {
        label: String,
        options: Array,
        selected: Array,
        checkAllBox: Boolean
    },
    model: {
        prop: 'selected',
        event: 'selectionChange'
    },

    data() {
        return {
            formItemLayout: {
                labelCol: { span: 24 },
                wrapperCol: { span: 24 }
            },
        }
    },

    computed: {
        allIndeterminate() {
            if (this.selected.length > 0 && this.selected.length < this.options.length) {
                return true;
            } else {
                return false;
            }
        },
        allChecked() {
            const allChecked = this.selected.length === this.options.length;
            return allChecked;
        },
        allValues() {
            return this.options.map(opt => opt.value);
        }
    },

    methods: {
        selectionChange(value) {
            this.$emit('selectionChange', value)
        },
        checkAllChange(event) {
            if (this.allChecked) {
                this.selectionChange([]);
            } else {
                this.selectionChange(this.allValues);
            }
        }
    },

    created() {
        if (this.checkAllBox) {
            this.selectionChange(this.allValues);
        }
    }
}
</script>

<style lang="scss">
</style>